import React from "react";
import { Link } from 'react-router-dom';
import PlacesAutocomplete from 'react-places-autocomplete';
import {getRadius} from '../../../helper';

/*global google*/

export default (props) => {

    const {
        handleOnChange,
        handleAddressText,
        getGeoCodeByAddress,
        handleCancel,
        onSubmit,

        state,
        title,
        comment,
        address,
        radius,
        isFetching,
        errorMessages,
    } = props;

    const inputProps = {
        required: true,
        placeholder: 'Район или радиус поиска на карте',
        value: address,
        onChange: (address) => handleAddressText(address),
    }

	return(
        <div className="white-block-content" style={{padding: '15px 30px 0 30px'}}>
            <div style={{padding: '30px'}}>
                <form
                    onSubmit={(e) => isFetching ? false : onSubmit(e)}
                    >
                    <div style={{marginBottom:'25px'}}>
                        <input
                            type="text"
                            placeholder="Заголовок"
                            required
                            className="width100"
                            style={{height:'40px'}}
                            value={title}
                            onChange={(e) => handleOnChange(e.target.value, 'title')}
                        />
                        {
                            errorMessages && errorMessages.title ?
                            <div className="input-error-text etmt10">{errorMessages.title}</div>
                            : null
                        }
                    </div>

                    <div style={{marginBottom:'25px'}}>
                        <div style={{position: 'relative', zIndex: 23}}>
                            <PlacesAutocomplete
                                inputProps={inputProps}
                                highlightFirstSuggestion
                                onSelect={(e) => getGeoCodeByAddress(e)}
                            />
                        </div>
                        {
                            errorMessages && errorMessages.address ?
                            <div style={{marginBottom:'10px'}} className="input-error-text etmt10">{errorMessages.address}</div>
                            : null
                        }
                    </div>

                    <div style={{marginBottom:'25px'}}>
                        <input
                            type="text"
                            placeholder="Комментарий к адресу (не обязательно)"
                            className="width100"
                            style={{height:'40px',}}
                            value={comment}
                            onChange={(e) => handleOnChange(e.target.value, 'comment')}
                        />
                        {
                            errorMessages && errorMessages.comment ?
                            <div style={{marginBottom:'10px'}} className="input-error-text etmt10">{errorMessages.comment}</div>
                            : null
                        }
                    </div>

                    <div style={{marginBottom:'25px'}}>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                            <input
                                style={{height:'40px', width: '150px'}}
                                type="number"
                                required
                                placeholder="Радиус"
                                min="0"
                                className="width100"
                                value={radius}
                                onChange={(e) => handleOnChange(e.target.value, 'radius')}
                            />

                            <div style={{fontWeight:'bold',marginLeft:'15px'}}>{getRadius(radius)}</div>
                        </div>

                        <div style={{fontStyle:'italic'}}>в метрах</div>

                        {
                            errorMessages && errorMessages.radius ?
                            <div style={{marginBottom:'10px'}} className="input-error-text etmt10">{errorMessages.radius}</div>
                            : null
                        }
                    </div>
                    
                    <div className="actions">
                        <div className="big-button empty-button">
                            {
                                state === "update" ?
                                <button onClick={(e) => handleCancel(e)}>Отмена</button>
                                :
                                <Link to="/account/locations">
                                    <button>Назад</button>
                                </Link>
                            }
                        </div>
                        {
                            <div className="big-button button-action">
                                <button
                                    disabled={isFetching ? true : false}
                                    className={isFetching ? 'disabled' : ''} >
                                    Сохранить
                                </button>
                            </div>
                        }
                    </div>
                </form>
                
                
            </div>
        </div>
	)
}


// WEBPACK FOOTER //
// ./src/components/Account/Locations/CreateForm.js